import { renderTrackingModulesScripts } from '../BookingFlowTracker';
import BookingFlowTrackerClass from '../BookingFlowTrackerClass';

const initTrackingModules = (isMultiProperty, enabledTrackingModules) => {
    renderTrackingModulesScripts(enabledTrackingModules, isMultiProperty);

    if (window.enabledTrackingModules) {
        window.BookingFlowTracker = new BookingFlowTrackerClass(window.enabledTrackingModules);
    }
};

export default initTrackingModules;
